import View from './views/View'

const route = {
    exact: true,
    purePath: '/registration',
    path: '/:lang/registration',
    component: View
}

export default route